import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const getUsersByQuery = async (data) => (
  axiosRequest({
    url: '/v1/user/get',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const getOne = async (data = {}) => (
  axiosRequest({
    url: '/v1/user/getone',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const getMessagesById = async (data = {}) => (
  axiosRequest({
    url: '/v1/message/getlatest',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const createUser = async (data = {}) => (
  axiosRequest({
    url: '/v1/user/create',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const deleteManyUsers = async (data = {}) => (
  axiosRequest({
    url: '/v1/user/deleteMany',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const updateUser = async (data = {}) => (
  axiosRequest({
    url: '/v1/user/update',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const archiveUser = async (data = {}) => (
  axiosRequest({
    url: 'v1/user/archive',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const createComment = async (data = {}) => (
  axiosRequest({
    url: '/v1/comment/create',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const getCommentsById = async (data = {}) => (
  axiosRequest({
    url: '/v1/comment/getlatest',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const createMessage = async (data = {}) => (
  axiosRequest({
    url: '/v1/message/create',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

export {
  getUsersByQuery,
  getOne,
  getMessagesById,
  getCommentsById,
  createUser,
  deleteManyUsers,
  updateUser,
  archiveUser,
  createComment,
  createMessage,
};
